var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"top-btn",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('img',{attrs:{"src":"https://img.davich.com/mobile/image/btn-top.png","alt":"top button icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }